import { useEffect, useState } from 'react';
import type { User } from '@vigie/shared';
import { api } from '../api.js';
import { Card, Field, Notice } from '../components.js';
import { useAction } from '../hooks.js';

export function Login({ onAuthenticated }: { onAuthenticated: (user: User) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const [allowSignup, setAllowSignup] = useState(false);
  const { run, busy, error } = useAction();

  useEffect(() => {
    api
      .config()
      .then((config) => setAllowSignup(config.allowSignup))
      .catch(() => setAllowSignup(false));
  }, []);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    const result = await run(() =>
      mode === 'login' ? api.login(email, password) : api.signup(email, password),
    );
    if (result) onAuthenticated(result.user);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <Card
          title={
            <div>
              <h1>Vigie</h1>
              <div className="small muted">Veille communautaire — portefeuille MCS</div>
            </div>
          }
        >
          <form onSubmit={submit}>
            <Field label="Email">
              <input
                type="email"
                value={email}
                autoComplete="username"
                required
                onChange={(event) => setEmail(event.target.value)}
              />
            </Field>
            <Field label="Mot de passe" help={mode === 'signup' ? '10 caractères minimum.' : undefined}>
              <input
                type="password"
                value={password}
                autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
                required
                onChange={(event) => setPassword(event.target.value)}
              />
            </Field>

            {error ? <Notice kind="error">{error}</Notice> : null}

            <div className="inline" style={{ marginTop: 12 }}>
              <button type="submit" className="primary" disabled={busy}>
                {mode === 'login' ? 'Se connecter' : 'Créer le compte'}
              </button>
              {allowSignup ? (
                <button
                  type="button"
                  className="ghost"
                  onClick={() => setMode(mode === 'login' ? 'signup' : 'login')}
                >
                  {mode === 'login' ? 'Créer un compte' : 'J’ai déjà un compte'}
                </button>
              ) : null}
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
}
